import { applyUserTranslationsAllTypes } from "@/lib/utils";
import type { IndicadoresMunicipio, ValoresMunicipio } from "@/types/models/indicadores";
import { indicadoresMunicipioRepository } from "../repositories/indicadores.repository";

export const indicadoresMunicipioService = {
  async fetchIndicadoresByTenant(params: { tenantId: number; userLang: string }): Promise<IndicadoresMunicipio[]> {
    const data = await indicadoresMunicipioRepository.fetchIndicadoresByTenant(params.tenantId);
    return applyUserTranslationsAllTypes(data ?? [], params.userLang, ["nombre", "descripcion"]);
  },

  async fetchValoresByTenant(params: { tenantId: number }): Promise<ValoresMunicipio[]> {
    return (await indicadoresMunicipioRepository.fetchValoresByTenant(params.tenantId)) ?? [];
  },

  async fetchValoresByIndicador(params: { indicadorId: number }): Promise<ValoresMunicipio[]> {
    return (await indicadoresMunicipioRepository.fetchValoresByIndicador(params.indicadorId)) ?? [];
  },

  createIndicador: indicadoresMunicipioRepository.createIndicador,
  updateIndicador: indicadoresMunicipioRepository.updateIndicador,
  deleteIndicador: indicadoresMunicipioRepository.deleteIndicador,
  createValores: indicadoresMunicipioRepository.createValores,
  updateValor: indicadoresMunicipioRepository.updateValor,
  deleteValor: indicadoresMunicipioRepository.deleteValor,
};